import * as $ from 'jquery';
import * as i18n from 'CMS/core/i18n';
import * as kendo from 'kendo/kendo.core';

import Popup from 'CMS/UI/Popup';

export interface IBaseDialogOptions {
    //TODO maxWidth, maxHeight, modal don't get used yet
    content?: JQuery | string | HTMLElement;
    title?: string;
    description?: string;
    modal?: boolean;
    width?: number;
    height?: number;
    maxWidth?: number;
    maxHeight?: number;
}

export abstract class BaseDialog {    
    protected options: IBaseDialogOptions;
    private _selection: any; //tslint:disable-line
    private $confirmButton: JQuery;
    private $cancelButton: JQuery;
    private popup: Popup;

    public get selection(): any {
        return this._selection;
    }

    constructor(options: IBaseDialogOptions) {
        this.options = options;
    }    

    public show(initialSelection: any = null): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this._selection = null;
            this.popup = new Popup(); 

            var $content = $('<div></div>');
            this.buildContent().then(($built) => {
                $content.append($built);

                var $buttonGroup = $('<div class="btn-group" style="width: 100%; margin-top: 10px;" role="group"></div>');
                this.$confirmButton = $('<button type="button" class="btn btn-primary button-ok capitalize">' + i18n.getMessage('dialog.ok') + '</button>');
                this.$cancelButton = $('<button type="button" class="btn btn-link button-cancel capitalize pull-right" style="margin-top: 12px">' + i18n.getMessage('dialog.cancel') + '</button>');

                $buttonGroup.append(this.$confirmButton);
                $buttonGroup.append(this.$cancelButton);
                $content.append($buttonGroup);

                this.completeContent($content);

                this.$confirmButton.on('click', (e) => {
                    e.preventDefault();
                    if (!this.$confirmButton.hasClass('disabled')) {
                        this.popup.close(this.selection);
                        resolve(this.selection);
                    }
                });

                this.$cancelButton.on('click', (e) => {
                    e.preventDefault();
                    this.popup.close(null);
                    resolve(null);
                });

                this.setInitialSelection(initialSelection);
                this.checkConfirmButton();

                this.popup.show({
                    draggable: false,
                    title: this.options.title,
                    content: $content,
                    width: this.options.width,
                    height: this.options.height,
                    close: (e) => {
                        this.popup = null;
                    }
                });

                this.onPopupShown();
            }, (error) => {
                console.error(error);
                reject();
            });
        });
    }

    private checkConfirmButton() {
        if (this.selection != null) {
            this.$confirmButton.removeClass('disabled');
        } else {
            this.$confirmButton.addClass('disabled');
        }
    }

    protected restore(): void {
        if (this.popup != null) {
            this.popup.restore();
        }
    }

    protected maximize(): void {
        if (this.popup != null) {
            this.popup.maximize();
            this.popup.resize();
        }
    }

    protected resize(): void {
        if (this.popup != null) {
            this.popup.resize();
        }
    }

    protected selectionChanged(selection: any) {
        this._selection = selection;
        this.checkConfirmButton();
    }

    protected onPopupShown() { }
    protected abstract buildContent(): Promise<JQuery>;
    protected abstract completeContent($content: JQuery): void;
    protected abstract setInitialSelection(selection: any): void;

}